import { useTranslation } from 'react-i18next';
import { useCustomerAnalyticsGetAmountOfScans } from '@app/domain/analytics/analytics.query.hooks';
import { useCustomerAnalyticsGlobalFilterParams } from '@app/domain/analytics/analytics.url.hooks';
import { QRLineChartBare } from './QRLineChartBare';
import { Container } from '@app/components';

export const QRAnalyticsTotalScansChart: React.FC = () => {
  const { t } = useTranslation();
  const filters = useCustomerAnalyticsGlobalFilterParams();
  const { data, isLoading } = useCustomerAnalyticsGetAmountOfScans(filters);

  return (
    <Container
      className="flex min-h-[340px] flex-col gap-4 lg:rounded-xl"
      isLoading={isLoading}
      title={t('qrAnalytics.amountOfScans')}
    >
      {data && <QRLineChartBare data={data} />}
    </Container>
  );
};
